export default "__VITE_ASSET__DRthdR3X__"